const PageHeightOffsets = Object.freeze({
  login: 400,
  offerList: 600,
});

export default PageHeightOffsets;
